import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

// @Injectable({ providedIn: "root" })
// export class PreviousFilingIdService {
//   private previousFilingIdSource = new BehaviorSubject<string | null>(
//     localStorage.getItem("previousFilingId")
//   );
//   previousFilingId$ = this.previousFilingIdSource.asObservable();

//   setPreviousFilingId(id: string) {
//     localStorage.setItem("previousFilingId", id);
//     this.previousFilingIdSource.next(id);
//   }
// }
@Injectable({ providedIn: "root" })
export class PreviousFilingIdService {
  private storageKey = "previousFilingInfo";

  private previousFilingSource = new BehaviorSubject<{
    filingId: string | null;
    filingState: string | null;
  }>(
    JSON.parse(localStorage.getItem("previousFilingInfo") || "null") ?? {
      filingId: null,
      filingState: null,
    }
  );

  previousFiling$ = this.previousFilingSource.asObservable();

  setPreviousFiling(id: string, state: string) {
    const filingInfo = { filingId: id, filingState: state };
    localStorage.setItem(this.storageKey, JSON.stringify(filingInfo));
    this.previousFilingSource.next(filingInfo);
  }

  getStoredFilingId(): string | null {
    const data = localStorage.getItem(this.storageKey);
    return data ? JSON.parse(data).filingId : null;
  }

  getStoredFilingState(): string | null {
    const data = localStorage.getItem(this.storageKey);
    return data ? JSON.parse(data).filingState : null;
  }
}
